import { createTheme } from '@material-ui/core';

const theme = createTheme({
  spacing: 8,
  palette: {
    type: 'light',
    primary: {
      light: '#fff',
      main: '#000',
      dark: '#808080',
      contrastText: '#fff',
    },
    secondary: {
      light: '#eb4637',
      main: '#eb4637',
      dark: '#eb4637',
      contrastText: '#000',
    },
    background: {
      default: '#fff',
    },
  },

  typography: {
    fontFamily: 'Rubik',
  },
});

theme.overrides = {
  ...theme.overrides,
  MuiAppBar: {
    colorPrimary: {
      backgroundColor: '#fff',
      color: '#000',
    },
  },
  MuiInputBase: {
    root: {
      fontSize: '14px',
    },
  },
  MuiFormLabel: {
    root: {
      fontSize: '14px',
    },
  },
  MuiInputLabel: {
    outlined: {
      transform: 'translate(14px, 17px) scale(1)',
    },
  },
  // .MuiAutocomplete-inputRoot-307[class*="MuiOutlinedInput-root"]
  MuiAutocomplete: {
    inputRoot: {
      '&&[class*="MuiOutlinedInput-root"] $input': {
        padding: 6,
      },
    },
  },
  MuiOutlinedInput: {
    input: {
      padding: '15px 14px',
    },
  },
  MuiChip: {
    root: {
      borderRadius: '4px',
      fontSize: 12,
    },
    outlined: {
      color: '#616161',
    },
  },
  MuiToggleButton: {
    root: {
      color: theme.palette.primary.main,
      '&$selected': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
    sizeSmall: {
      padding: '6px 20px',
    },
  },
  MuiCardContent: {
    root: {
      '&:last-child': {
        paddingBottom: 16,
      },
    },
  },
};

export default theme;
